import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const stepColor = (status?: string) => {
  switch (status) {
    case "completed":
      return "#16a34a";
    case "inprogress":
      return "#2563eb";
    default:
      return "#d1d5db";
  }
};

const ProgressBar: React.FC<{ label: string; completed: number; total: number; status?: string }> = ({
  label,
  completed,
  total,
  status,
}) => {
  const { effectiveTheme } = useTheme();
  const isDark = effectiveTheme === "dark";
  const pct = total > 0 ? Math.round((completed / total) * 100) : status === "completed" ? 100 : 0;

  return (
    <div style={{ marginBottom: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "7px" }}>
        <span style={{ fontWeight: 600, color: isDark ? "#e2e8f0" : "#374151" }}>{label}</span>
        <span style={{ color: isDark ? "#94a3b8" : "#6b7280" }}>
          {completed}/{total} ({pct}%)
        </span>
      </div>
      <div style={{ height: "9px", background: isDark ? "rgba(148,163,184,0.15)" : "#f3f4f6", borderRadius: "999px", overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, background: stepColor(status), borderRadius: "999px" }} />
      </div>
    </div>
  );
};

export const PENDING_REASON_LABELS: Record<string, string> = {
  sequence_pending: "Sequence not built yet",
  scraping_pending: "Still scraping emails",
  verification_pending: "Still verifying emails",
};

export const PendingReasonBanner: React.FC<{ reasons: string[] }> = ({ reasons }) => {
  const { effectiveTheme } = useTheme();
  const isDark = effectiveTheme === "dark";

  if (!reasons?.length) return null;

  return (
    <div
      style={{
        background: isDark ? "rgba(217,119,6,0.15)" : "#fffbeb",
        border: `1px solid ${isDark ? "rgba(217,119,6,0.35)" : "#fde68a"}`,
        borderRadius: "10px",
        padding: "12px 14px",
        fontSize: "12.5px",
        color: isDark ? "#fbbf24" : "#92400e",
        marginBottom: "20px",
      }}
    >
      <strong>What's left: </strong>
      {reasons.map((r) => PENDING_REASON_LABELS[r] || r).join(", ")}
    </div>
  );
};

export default ProgressBar;
